<template>
  <div>
    <MapViewer
      :format="format"
      :publisherId="publisherId"
      :mapId="mapId"
      :lang="lang"
      :customSearchButtonLabel="customSearchButtonLabel"
      :topLeftBounds="parsedTopLeft"
      :bottomRightBounds="parsedBottomRight"
    />
  </div>
</template>

<script>
import MapViewer from './MapViewer';
import {fromString } from '@/gis/Location'

export default {
  components: {
    MapViewer,
  },

  props: {
    publisherId: { type: String },
    mapId: { type: String },
    customSearchButtonLabel: { type: String },
    topleftbounds: { type: String },
    bottomrightbounds: { type: String },
    format: { type: String, default: 'map' },
    lang: { type: String, default: 'en' },
  },
  computed: {
    parsedTopLeft() {
      return fromString(this.topleftbounds);
    },
    parsedBottomRight() {
      return fromString(this.bottomrightbounds);
    },
  },

  methods: {
    loadWebViewer(webViewerId) {
      console.log('todo ' + webViewerId);
    },
  },

};
</script>
